module.exports = __webpack_public_path__ + "static/img/Logo-App-Goship2.5c7f941.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo-App-Goship2.png
// module id = Oz82
// module chunks = 134